import { render, staticRenderFns } from "./MatckCardConfig.vue?vue&type=template&id=4ddef1cc&scoped=true"
import script from "./MatckCardConfig.vue?vue&type=script&lang=js"
export * from "./MatckCardConfig.vue?vue&type=script&lang=js"
import style0 from "./MatckCardConfig.vue?vue&type=style&index=0&id=4ddef1cc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddef1cc",
  null
  
)

export default component.exports